import * as MaterialIcons from "@mui/icons-material";
import React from "react";

/**
 * Resolves an icon from a passed prop value.
 *
 * If the prop is a React node, it is passed through unchanged.
 * If the prop is a string, it is resolved against the
 * `@mui/icons-material` namespace (e.g. `"Home"`, `"InfoOutlined"`).
 *
 * @returns The resolved icon node, or null if no prop is passed.
 */
export function resolveIcon(iconProp?: React.ReactNode | string) {
  if (!iconProp) return null;
  if (typeof iconProp !== "string") return iconProp;
  const IconComponent = (MaterialIcons as Record<string, unknown>)[iconProp];
  return React.createElement(IconComponent as React.ElementType);
}
